/* eslint-disable max-len */
import * as React from 'react';
import { cn } from '@/util/cn';

// SnowMark — the OnTheSnow brand snowflake mark. Four asymmetric
// pinwheel arms around a center. Use it as a brand accent (logo lockup
// secondary mark) or as a large faded watermark behind featured
// content. Pair with `currentColor` and `text-*` utilities to tint.

type Props = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

export const SnowMark = React.forwardRef<SVGSVGElement, Props>(
  ({ className, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 201 192"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      aria-hidden="true"
      className={cn('text-current', className)}
      {...props}
    >
      <path d="M115.711 49.612L90.486 0 78.49 36.324l25.235 49.657 49.722-25.06 11.959-36.28-49.696 24.97zM84.985 142.467l25.224 49.602 11.977-36.342-25.189-49.603-49.793 25.025-11.934 36.342 49.715-25.024zM150.838 112.613l49.859-25.08-36.539-11.965-49.858 25.08 25.189 49.512 36.484 11.919-25.135-49.466zM49.84 79.538L0 104.636l36.514 11.92L86.379 91.44 61.208 41.992 24.705 30.036 49.84 79.538z" />
    </svg>
  ),
);
SnowMark.displayName = 'SnowMark';
